let initialized = false
let debug = false
let cookiebotDialogElement = false

let currentConsent = {
  marketing: false,
  preferences: false,
  statistics: false
}

const defaultOptions = {
  domainGroupId: '34f20728-96de-4e46-85b2-09e2fd500260',
  debug: false,
  language: false
}

const customBannerID = 'CookiebotCustomBanner'

// create our custom banner and attach to DOM
const createCustomCookieBanner = () => {
  
  destroyCustomCookieBanner()

  const bannerData = getDataFromCookiebotDialog()

  let node = document.createElement( 'div' )
  node.id = customBannerID

  let body = document.createElement( 'div' )
  body.classList.add( 'ccb-body' )

  body.innerHTML = `<h2 class='ccb-body__title'>${bannerData.body.title}</h2>
                    <p class='ccb-body__text'>${bannerData.body.text}</p>`
  
  node.appendChild( body )

  let buttons = document.createElement( 'div' )
  buttons.classList.add( 'ccb-buttons' )

  buttons.innerHTML = `<a id='ccbButtonAcceptAll' class='ccb-button' href='#' tabindex='0'>${bannerData.buttons.allowAll}</a>
                        <a id='ccbButtonShowConsentDetails' class='ccb-button ccb-button--white' href='#' tabindex='1'>${bannerData.buttons.showSettings}</a>
                        <a id='ccbButtonAllowSelection' class='ccb-button ccb-button--white' href='#' tabindex='2'>${bannerData.buttons.allowSelection}</a>`

  node.appendChild( buttons )

  let consent = document.createElement( 'div' )
  consent.classList.add( 'ccb-consent' )

  let checkboxes = ''
  Object.entries( bannerData.consent ).forEach( (item, index ) => {
    const [key, value] = item
    let cb = `<div class='ccb-consent__checkbox ccb-consent__checkbox--${key}'>
                <input type='checkbox' id='ccbConsentCheckbox_${key}' ${isCheckboxChecked( value )} ${isCheckboxDisabled( key )} tabindex='${index+3}' />
                <label for='ccbConsentCheckbox_${key}'>
                  ${value.label}
                </label></div>`
    checkboxes += cb
  })

  consent.innerHTML = `<div class='ccb-consent__checkboxes'>${checkboxes}</div>`
  
  node.appendChild( consent )

  document.body.appendChild( node )

  node.querySelectorAll('.ccb-button').forEach( btn => {
    btn.addEventListener( 'click', handleCustomCookiebannerButtonClick )
  })
}

const isCheckboxChecked = ( item ) => {
  return item.value ? " checked" : ""
}

const isCheckboxDisabled = ( key ) => {
  return key == "necessary" ? " disabled"  : ""
}

const handleCustomCookiebannerButtonClick = (e) => {
  e.preventDefault()
  e.returnValue = false

  switch ( e.target.id ) {    
    case 'ccbButtonAcceptAll':
      acceptAllCookiesAndDestroyCustomCookiebanner()
      break;
    case 'ccbButtonShowConsentDetails':
      showCustomCookiebannerDetails()
      break;
    case 'ccbButtonAllowSelection':
      acceptSelectedCookiesAndDestroyCustomCookiebanner()
      break;
    default:
  }

}

// submit consent for all cookie categories
const acceptAllCookiesAndDestroyCustomCookiebanner = () => {
  // optinPreferences, optinStatistics, optinMarketing
  window.Cookiebot.submitCustomConsent(true, true, true )
  destroyCustomCookieBanner()
}

// submit consent for selected cookie categories
const acceptSelectedCookiesAndDestroyCustomCookiebanner = () => {

  const el = document.getElementById( customBannerID )
  
  const preferences = el.querySelector( '#ccbConsentCheckbox_preferences' ).checked
  const statistics = el.querySelector( '#ccbConsentCheckbox_statistics' ).checked
  const marketing = el.querySelector( '#ccbConsentCheckbox_marketing' ).checked
  
  // optinPreferences, optinStatistics, optinMarketing
  window.Cookiebot.submitCustomConsent(preferences, statistics, marketing )
  destroyCustomCookieBanner()
}

// add class so the cookie category checkboxes are shown
const showCustomCookiebannerDetails = () => {
  const el = document.getElementById( customBannerID )
  el.classList.add( 'show-consent-details' )
}

const destroyCustomCookieBanner = () => {

  const el = document.getElementById( customBannerID )
  
  if( !el ) {
    return
  }

  el.parentNode.removeChild( el )

  destroyCustomCookieBanner()
}

// get copy from cookiebot banner and the consented categories 
const getDataFromCookiebotDialog = () => {

  const cookiebotDialogElement = document.querySelector( '#CybotCookiebotDialog' )
  if( !cookiebotDialogElement ) {
    return false
  }

  let necessaryParentNode = cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonNecessary' ).parentNode
  let preferencesParentNode = cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonPreferences' ).parentNode
  let statisticsParentNode = cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonStatistics' ).parentNode
  let marketingParentNode = cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonMarketing' ).parentNode

  return {
    body: { 
      title: cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyContentTitle' ).innerHTML,
      text: cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyContentText' ).innerHTML
    },
    buttons: {
      allowAll: cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll' ).innerHTML,
      showSettings: cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelDetailsButton' ).innerHTML,
      allowSelection: cookiebotDialogElement.querySelector( '#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection' ).innerHTML
    },
    consent: {
      necessary: {
        info: necessaryParentNode.getAttribute('title'),
        label: necessaryParentNode.querySelector('label').innerHTML,
        value: true
      },
      preferences: {
        info: preferencesParentNode.getAttribute('title'),
        label: preferencesParentNode.querySelector('label').innerHTML,
        value: preferencesParentNode.querySelector('input').checked ? true : false
      },
      statistics: {
        info: statisticsParentNode.getAttribute('title'),
        label: statisticsParentNode.querySelector('label').innerHTML,
        value: statisticsParentNode.querySelector('input').checked ? true : false
      },
      marketing: {
        info: marketingParentNode.getAttribute('title'),
        label: marketingParentNode.querySelector('label').innerHTML,
        value: marketingParentNode.querySelector('input').checked ? true : false
      }
    }

  }

}

// Cookiebot callbacks
const initializeCookiebotCallbacks = () => {	

  window.CookiebotCallback_OnDialogDisplay = () => {
    if( debug ) {      
      console.log( 'CookiebotCallback_OnDialogDisplay', window.Cookiebot, currentConsent )
    }
    createCustomCookieBanner()
  }

} 

// https://support.cookiebot.com/hc/en-us/articles/360016047000-Cookiebot-and-Google-Consent-Mode
const addGoogleConsetModeGTMDataLayer = () => {

  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }

  gtag("consent", "default", {
    ad_storage: "denied",
    analytics_storage: "denied",
    wait_for_update: 500
  })

  gtag("set", "ads_data_redaction", true)

}

const addCookiebotScript = ( domainGroupId, language, auto ) => {

  const scriptID = 'CookiebotScript'

  // probably not neccesary to do this double check but doesn't hurt
  if (document.getElementById(scriptID) || window.Cookiebot) {
    if( debug ) {
      console.log( 'addCookiebotScript: cookiebot already in place' )
    }
    return
  }

  const script = document.createElement('script')
  script.setAttribute('id', scriptID)
  script.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
  script.setAttribute('data-cbid', domainGroupId)
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('data-blockingmode', 'auto')

  if (language) {
    script.setAttribute('data-culture', language.slice(0,2))
  }
  const head = document.querySelector('html > head')
  head.insertBefore(script, head.firstChild)

  if( debug ) {
    console.log( 'addCookiebotScript: cookiebot script added' )
  }

}

const cookiebotDisabled = () => {
  return new Promise( ( resolve ) => {
    if( initialized ){
      resolve({ status: 'ready'})
    } else {
      initialized = true
      resolve({ status: 'loaded' })
    }
  })
}

const cookiebotEnabled = (options) => {

  options = { ...defaultOptions, ...options }

  debug = options.debug

  if( !initialized ) {

    initializeCookiebotCallbacks()

    addGoogleConsetModeGTMDataLayer()

    addCookiebotScript( options.domainGroupId, options.language )

    initialized = true

  }

  // Cookiebot script has been added to head. We want to make sure that window.Cookiebot exists 
  // Polling for it is faster than waiting for the events fired by cookiebot
  return new Promise( ( resolve ) => {

    if( window.Cookiebot ) {
      if( debug ) {
        console.log( 'Cookiebot.init: window.Cookiebot already loaded' )
        console.log( window.Cookiebot.windowOnloadTriggered )
      }

      resolve( { status: 'ready' } )

    } else {

      // If window.Cookiebot hasn't been loaded withing 6 seconds resolve but with error
      const timeoutTimer = setTimeout(() => {
        clearInterval( pollTimer )
        resolve( { status: 'timedout' } )
      }, 6000 )

      // Start an interval polling for window.Cookiebot as that finds it a bit faster than waiting for events / callbacks fired from Cookiebot
      const pollTimer = setInterval(() => {
        if( window.Cookiebot ) {
          if( debug ) {
            console.log( 'Cookiebot.init: found window.Cookiebot by polling' )
            console.log( window.Cookiebot.windowOnloadTriggered )
          }
          clearInterval( pollTimer )
          clearTimeout( timeoutTimer )
          resolve( { status: 'loaded' } )
        }
      }, 250)

    }

  })
}

// only run cookiebot if it's been set as an .env variable
// if not then simply base the resolve on if initialized has been set to true (this is so we don't add tracker over and over and over)
const Cookiebot = {

  init( options ) {

    if( process.env.GATSBY_COOKIEBOT ) {
      return cookiebotEnabled( options )
    } else {
      return cookiebotDisabled()
    }

  }
}

export default Cookiebot
